import { notification } from "antd";
import { useTranslation } from "react-i18next";
import { BiChevronLeft } from "react-icons/bi";
import Button from "shared/components/Button";
import Card from "shared/components/Card";
import Dragger from "shared/components/Input/File/Dragger";
import { useMutation } from "shared/hooks/useApi";
import { NAME_SPACES } from "shared/locales/constants";
import graphql from "utils/api/graphql";

// The anchor syntax shown to the user. Passed through interpolation rather than
// written in the translation, whose own {{ }} would be interpolated away.
const ANCHOR_TOKEN = "{{...}}";
const ANCHOR_SAMPLE = "{{ancre}}";

const StepUpload = ({ onNext, onBack }) => {
  const { t } = useTranslation(NAME_SPACES.PRIVATE.ADMIN.DYNAMIC_DOCUMENTS);
  const UPLOAD = t("UPLOAD", { returnObjects: true });

  const [detectAnchors, { loading }] = useMutation(
    graphql.mutations.DETECT_DOCUMENT_ANCHORS,
  );

  const handleFileUpload = async (info) => {
    const raw = info.fileList?.[0]?.originFileObj || info.file;
    if (!raw) return [];
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.onload = async (e) => {
        const base64 = e.target.result.split(",")[1];
        const file = { content: base64, name: raw.name, contentType: raw.type };
        try {
          const { data } = await detectAnchors({ variables: { file } });
          const anchors = data?.detectDocumentAnchors || [];
          if (anchors.length === 0) {
            notification.warning({
              message: UPLOAD.NO_ANCHOR,
              description: t("UPLOAD.NO_ANCHOR_DESCRIPTION", {
                token: ANCHOR_TOKEN,
              }),
            });
          }
          onNext({ file, anchors });
        } catch {
          notification.error({ message: UPLOAD.ERROR });
        }
        resolve([raw]);
      };
      reader.readAsDataURL(raw);
    });
  };

  return (
    <Card type="simple">
      <div className="pricers-import__card-header">
        <div>
          <h3 className="pricers-import__card-title">{UPLOAD.TITLE}</h3>
          <p className="pricers-import__card-description">
            {UPLOAD.DESCRIPTION_BEFORE} <code>{ANCHOR_SAMPLE}</code>
            {UPLOAD.DESCRIPTION_AFTER}
          </p>
        </div>
        <Button type="primary--outlined" onClick={onBack}>
          <BiChevronLeft size={18} />
          {UPLOAD.BACK}
        </Button>
      </div>
      <div className="pricers-import__card-body">
        <Dragger
          handleFileUpload={handleFileUpload}
          onUpload={() => {}}
          accept=".pdf"
          maxCount={1}
          beforeUpload={() => false}
          loading={loading}
        />
        {loading && (
          <p className="dynamic-documents__analyzing">{UPLOAD.ANALYZING}</p>
        )}
      </div>
    </Card>
  );
};

export default StepUpload;
